<div>
  @switch (formGroup.value.type) {
    @case ('ejendomsfaktorer') {
      <div>
        <ejendomsfaktor-liste [formGroup]="formGroup.get('data')" [ejendomsfaktorDefinitioner]="ejendomsfaktorDefinitioner">
        </ejendomsfaktor-liste>
      </div>
    }
    @case ('komponentgruppe') {
      <div>
        <komponent-gruppe [formGroup]="formGroup.get('data')" [komponentTyper]="komponentTyper" (opret)="opretKomponent.emit($event)">
        </komponent-gruppe>
      </div>
    }
    @case ('noter') {
      <div>
        <opgave-note-liste [formGroup]="formGroup.get('data')"> </opgave-note-liste>
      </div>
    }
    @case ('maalerskift') {
      <div>
        <maalerskift [formGroup]="formGroup.get('data.maalerskift')"> </maalerskift>
      </div>
    }
    @case ('installationsoprettelse') {
      <div>
        <installationsoprettelse [formGroup]="formGroup.get('data.installationsoprettelse')"> </installationsoprettelse>
      </div>
    }
    @case ('send-mail-til-forbruger') {
      <div>
        <send-mail-til-forbruger [formGroup]="formGroup.get('data.sendMailTilForbruger')"> </send-mail-til-forbruger>
      </div>
    }
    @case ('batteriskift') {
      <div>
        <batteriskift [formGroup]="formGroup.get('data.batteriskift')"> </batteriskift>
      </div>
    }
    @default {
      <div>
        <div>Ukendt arbejdsgang: '{{ formGroup.value.type }}'.</div>
      </div>
    }
  }
</div>
